export default __webpack_public_path__ + "static/malmsteen-5e30eb9b85a4c7f2b236a4614f66c6eb.gif";